// extracted by mini-css-extract-plugin
export default {"div":"MainLayout_div__LZ3Fn"};